module.exports = __webpack_public_path__ + "static/media/bromley-arena.d972702f.md";